/** @format */

"use client";
import React, { useEffect, useState } from "react";
import "./Footer.css";
import { apiService } from "@/services/api.services";
import Image from "next/image";
import Link from "next/link";
import FooterLogo from "@/Helper/images/new/Footer_logo.svg";
import FooterLocIcon from "@/Helper/images/new/footer_locicon.svg";
import TooglePlus from "@/Helper/images/new/toggle_plus.svg";
import ToogleMinus from "@/Helper/images/new/toggle_minus.svg";
import FooterEmail from "@/Helper/images/new/footer_email.svg";
import FooterCall from "@/Helper/images/new/footer_call.svg";
import FaceBookIco from "@/Helper/images/new/footer_facebook.svg";
import LinkedInIco from "@/Helper/images/new/footer_linkedin.svg";
import XIco from "@/Helper/images/new/footer_x.svg";
import InstaIco from "@/Helper/images/new/footer_instagram.svg";
import YouTubeIco from "@/Helper/images/new/footer_youtube.svg";
import LanguageIcon from "@mui/icons-material/Language";
import FaqLogo from "@/Helper/images/new/applications/faq_logo.svg";
import IndiaFlag from "@/Helper/images/new/india_flag.svg";
import UsaFlag from "@/Helper/images/new/usa-flag.svg";
import UkFlag from "@/Helper/images/new/uk-flag.svg";

import FooterContactForm from "@/app/contact-us/FooterContactForm";

const Footer = () => {
  const [footerData, setFooterData] = useState(null);
  const [error, setError] = useState(null);
  const [openSection, setOpenSection] = useState("usa");
  const [openProductSection, setOpenProductSection] = useState(null);
  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  const toggleProductSection = (section) => {
    setOpenProductSection((prev) => (prev === section ? null : section));
  };

  useEffect(() => {
    async function fetchFooterData() {
      try {
        const resp = await apiService.getAllUtilityData();
        if (resp.status === 200) {
          setFooterData(resp.data?.data?.attributes);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err);
      }
    }

    fetchFooterData();
  }, []);
  if (error) {
    return <div>Error: {error.message}</div>;
  }
  const socialMediaLinks = [
    {
      name: "Facebook",
      icon: FaceBookIco,
      url: "https://www.facebook.com/FlexShaft#",
      width: 11,
      height: 18,
    },
    {
      name: "X",
      icon: XIco,
      url: "https://x.com/sswhitetech",
      width: 15,
      height: 15,
    },
    {
      name: "Linked in",
      icon: LinkedInIco,
      url: "https://www.linkedin.com/company/sswhitetech/",
      width: 19,
      height: 18,
    },
  ];
  const addresses = {
    usa: {
      location: "8300 Sheen Drive, St. Petersburg, FL, 33709",
      email: "sales@sswhite.net",
      phone: "+1 727-626-2800",
    },
    uk: {
      location: "28 Alston Drive, Bradwell Abbey, Milton Keynes MK13 9HA",
      email: "uksales@sswhite.net",
      phone: "01908 525120",
      websiteurl: "www.sswhite.co.uk ",
      websiteurl1: "https://www.sswhite.co.uk/",
    },
    india: {
      location:
        "Survey No. 2788/3, Wadhwan-Ahmedabad Highway,​ Near Krishna Petrol Pump, Wadhwan-363030. Dist: Surendranagar, Gujarat India",
      email: "salesindia@sswhite.net",
      phone: "(02752) 287503",
      websiteurl: "www.sswhite.co",
      websiteurl1: "https://www.sswhite.co/",
    },
  };

  return (
    <footer className="footer_area ">
      <div className="container">
        <div className=" footer_container ">
          <div className=" footer_content_container">
            <div className="footer_contact_area">
              <div className="footer_contact_logosec">
                <Image src={FooterLogo} alt="logo" width={224} height={56} />
                <p>
                  S.S. White leads the world in Flexible Shaft technology and
                  innovation. We are known throughout the world for having the
                  best performing, highest quality Flexible Shafts.
                </p>
              </div>
              <div className="footer_addresscontainer">
                <p className="footer_heading">Address</p>
                {[
                  {
                    title: "USA - Corporate Headquarters",
                    key: "usa",
                    flag: UsaFlag,
                  },
                  { title: "UK - Branch Office", key: "uk", flag: UkFlag },
                  {
                    title: "India - Manufacturing Facility",
                    key: "india",
                    flag: IndiaFlag,
                  },
                ].map(({ title, key, flag, websiteurl, websiteurl1 }) => (
                  <div className="footer_addresslist" key={key}>
                    <div
                      className="footer_addresslisttop"
                      onClick={() => toggleSection(key)}
                    >
                      <p className="address_hd">
                        <span>
                          <Image
                            src={flag}
                            alt={title}
                            width={20}
                            height={20}
                          />{" "}
                          {title}
                        </span>
                        <Image
                          src={openSection === key ? ToogleMinus : TooglePlus}
                          alt={title}
                          width={24}
                          height={24}
                        />
                      </p>
                    </div>

                    {openSection === key && (
                      <div className="footer_addresslistmid">
                        <div className="footer_addresslistmidinner">
                          <p className="address_count">
                            <Image
                              src={FooterLocIcon}
                              alt="Location"
                              width={18}
                              height={18}
                            />
                            {addresses[key].location}
                          </p>
                        </div>
                        <div className="footer_addresslistmidinner">
                          <p className="address_count">
                            <Image
                              src={FooterEmail}
                              alt="Email"
                              width={18}
                              height={18}
                            />
                            {addresses[key].email}
                          </p>
                        </div>
                        <div className="footer_addresslistmidinner">
                          <p className="address_count">
                            <Image
                              src={FooterCall}
                              alt="Phone"
                              width={18}
                              height={18}
                            />
                            {addresses[key].phone}
                          </p>
                        </div>
                        {addresses[key].websiteurl1 &&
                          addresses[key].websiteurl && (
                            <div className="footer_addresslistmidinner">
                              <p className="address_count">
                                <LanguageIcon
                                  style={{ fontSize: "19px", marginTop: "3px" }}
                                />
                                <a
                                  href={addresses[key].websiteurl1}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {addresses[key].websiteurl}
                                </a>
                              </p>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="footer_social_links">
                <div className="social_icons">
                  {socialMediaLinks.map(
                    ({ name, icon, url, width, height }) => (
                      <a
                        key={name}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social_link"
                      >
                        <Image
                          src={icon}
                          alt={name}
                          width={width}
                          height={height}
                        />
                      </a>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="footer_listmenu footer_listmenusecond">
              <div className="footer_listmenubx">
                <p className="footer_heading">PRODUCTS</p>
                <ul className="footer_listmenuul">
                  <li>
                    <p className="footer_text">
                      <Link href={"/custom-shaft-design"}>
                        Custom Shaft Design
                      </Link>
                    </p>
                  </li>
                  <li>
                    <p
                      className="footer_text footer_texttoggle"
                      onClick={() => toggleProductSection("ready-flex")}
                    >
                      <span>Ready-Flex Shaft</span>
                      <Image
                        src={
                          openProductSection === "ready-flex"
                            ? ToogleMinus
                            : TooglePlus
                        }
                        alt="Toggle"
                        width={24}
                        height={24}
                      />
                    </p>
                    {openProductSection === "ready-flex" && (
                      <ul className="footer_listmenuul footer_listmenuulsubmenu">
                        <li>
                          <p className="footer_text">
                            <Link href={"/standard-flexible-shaft"}>
                              Standard Flexible Shaft
                            </Link>
                          </p>
                        </li>
                        <li>
                          <p className="footer_text">
                            <Link href={"/flexible-shaft-with-casing"}>
                              Ready-Flex With Casing
                            </Link>
                          </p>
                        </li>
                        <li>
                          <p className="footer_text">
                            <Link href={"/flexible-shaft-with-fittings"}>
                              Flexible Shaft With Fittings
                            </Link>
                          </p>
                        </li>
                        <li>
                          <p className="footer_text">
                            <Link href={"/flexible-shaft-w-casing-fittings"}>
                              Flexible Shaft With Casings & Fittings
                            </Link>
                          </p>
                        </li>
                      </ul>
                    )}
                  </li>

                  <li>
                    <p className="footer_text">
                      <Link href={"/gear-boxes"}>Gear Boxes</Link>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="footer_listmenubx">
                <p className="footer_heading">APPLICATIONS</p>
                <ul className="footer_listmenuul">
                  <li>
                    <p className="footer_text">
                      <Link href={"/aerospace"}>Aerospace</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/automotive"}>Automotive</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/medical"}>Medical</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/industrial"}>Industrial</Link>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer_listmenu footer_listmenusecond">
              <div className="footer_listmenubx">
                <p className="footer_heading">QUICK LINKS</p>
                <ul className="footer_listmenuul">
                  <li>
                    <p className="footer_text">
                      <Link href={"/"}>Home</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/about-us"}>About Us</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/careers"}>Careers</Link>
                    </p>
                  </li>

                  <li>
                    <Link href={"/blog"}>
                      {" "}
                      <p className="footer_text">Blog</p>
                    </Link>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/testimonials"}>Testimonials</Link>
                    </p>
                  </li>
                  {/* <li>
                    <p className="footer_text"><Link href={"/"}>Terms & Conditions</Link></p>
                  </li> */}
                  <li>
                    <p className="footer_text">
                      <Link href={"/privacy-policy"}>Privacy Policy</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer_text">
                      <Link href={"/terms-definitions"}>
                        Terms & Definitions
                      </Link>
                    </p>
                  </li>
                  {/* <li>
                    <p className="footer_text"><Link href={"/"}>FAQs</Link></p>
                  </li> */}
                  <li>
                    <p className="footer_text">
                      <Link href={"/contact-us"}>Contact Us</Link>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="footer_listmenu footer_listform">
              <p className="footer_heading">Contact us</p>

              <div className="footer_form">
                <FooterContactForm />
              </div>
            </div>
            <div className="faq_logsc1 faq_pulse ">
              <Link href={"/faq"}>
                <Image src={FaqLogo} alt="Faq" width={80} height={50} />
              </Link>
            </div>
          </div>
          <div className="footer_cpyright">
            {/* <p>{footerData?.rights_reserved}</p> */}
            <p>© 2025 S.S. White Technologies Inc. All Rights Reserved.</p>
            <p>
              Powered by{" "}
              <Link
                href="https://www.nextbraintech.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Nextbrain
              </Link>
            </p>
          </div>
        </div>
      </div>
      <noscript>
        {/* Google Tag Manager (noscript) */}
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-K78GXDXC"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
        {/* End Google Tag Manager (noscript) */}
      </noscript>
    </footer>
  );
};

export default Footer;
